import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
export function downloadPdf(_x, _x2) {
  return _downloadPdf.apply(this, arguments);
}
function _downloadPdf() {
  _downloadPdf = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(elements, fileName) {
    var _yield$import, StyleSheet, Document, Page, Text, pdf, styles, Doc, asPdf, blob, a;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return import('@react-pdf/renderer');
        case 2:
          _yield$import = _context.sent;
          StyleSheet = _yield$import.StyleSheet;
          Document = _yield$import.Document;
          Page = _yield$import.Page;
          Text = _yield$import.Text;
          pdf = _yield$import.pdf;
          styles = StyleSheet.create({
            body: {
              paddingVertical: 35,
              paddingHorizontal: 35
            },
            text: {
              margin: 12,
              fontSize: 12,
              textAlign: 'justify'
            },
            header: {
              fontSize: 18,
              margin: 12
            },
            title: {
              fontSize: 24,
              textAlign: 'center'
            }
          });
          Doc = function Doc() {
            return /*#__PURE__*/React.createElement(Document, null, /*#__PURE__*/React.createElement(Page, {
              style: styles.body
            }, elements.map(function (ele, i) {
              return /*#__PURE__*/React.createElement(Text, {
                key: i,
                style: styles[ele.type]
              }, ele.text);
            })));
          };
          asPdf = pdf([]);
          asPdf.updateContainer(/*#__PURE__*/React.createElement(Doc, null));
          _context.next = 14;
          return asPdf.toBlob();
        case 14:
          blob = _context.sent;
          a = document.createElement('a');
          document.body.appendChild(a);
          a.style = 'display: none';
          a.href = window.URL.createObjectURL(blob);
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(a.href);
          a.remove();
        case 23:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _downloadPdf.apply(this, arguments);
}
//# sourceMappingURL=pdfUtil.js.map
